import request from '@/utils/request'

// 获取考试分析数据
export function getExamAnalysis(examId) {
  return request({
    url: `/exam-analysis/${examId}`,
    method: 'get'
  })
}

// 获取考试详细分析数据
export function getExamDetailAnalysis(examId) {
  return request({
    url: `/exam-detail-analysis/${examId}`,
    method: 'get'
  })
}

// 获取题目详细分析数据
export function getQuestionDetailAnalysis(examId, questionId) {
  return request({
    url: `/exam-detail-analysis/${examId}/question/${questionId}`,
    method: 'get'
  })
}

// 获取学生答题详情数据
export function getStudentAnswerDetails(examId, questionId) {
  return request({
    url: `/exam-detail-analysis/${examId}/student-answers`,
    method: 'get',
    params: { questionId }
  })
}

// 生成考试分析报告
export function generateAnalysisReport(examId) {
  return request({
    url: `/exam-analysis/${examId}/report`,
    method: 'post'
  })
}

// 导出考试分析报告
export function exportAnalysisReport(examId) {
  return request({
    url: `/exam-detail-analysis/${examId}/export`,
    method: 'post'
  })
}

// 更新考试统计数据
export function updateExamStatistics(examId) {
  return request({
    url: `/exam-analysis/${examId}/statistics`,
    method: 'put'
  })
}

// 获取班级试卷分析（paperAnalysis.vue 使用）
export function getClassPaperAnalysis(examId) {
  return request({
    url: `/paper-analysis/${examId}`,
    method: 'get'
  })
}
